module.exports = __webpack_public_path__ + "static/OCRB-74e37a914d2ea2a7da8555e391f36090.woff2";